import React from 'react';
import { Phone, ShieldAlert, ArrowRight } from 'lucide-react';
export function FinalCta() {
  return <section className="py-20 md:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50 border-t border-slate-200 text-center" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <div className="inline-flex items-center gap-2 bg-brand-redLight text-brand-red px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-brand-redBorder" data-id="element-66">
          <ShieldAlert className="w-4 h-4" data-id="element-67" />
          <span data-id="element-68">Don't Wait — Damage Can Spread</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-5 tracking-tight leading-tight" data-id="element-69">
          <span className="text-brand-red" data-id="element-70">Broken Windshield</span> or Car
          Window Today?
        </h2>

        <p className="text-lg text-slate-600 mb-10 leading-relaxed" data-id="element-71">
          Do not wait for urgent auto glass damage to get worse. Call Kosin's
          Glass now or request an urgent quote and get help confirming the
          safest, fastest available repair or replacement option.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3 mb-6" data-id="element-72">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-73">
            <Phone className="w-5 h-5" data-id="element-74" />
            Call 517-545-7772 Now
          </a>
          <a href="#quote-form" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-100 text-slate-900 border border-slate-300 px-7 py-4 rounded-lg font-bold text-base transition-colors" data-id="element-75">
            Request Urgent Auto Glass Quote
            <ArrowRight className="w-4 h-4" data-id="element-76" />
          </a>
        </div>

        <p className="text-sm text-slate-500" data-id="element-77">
          Same-day openings may be available depending on glass availability and
          schedule.
        </p>
      </div>
    </section>;
}